import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  InputNumber,
  Checkbox,
  message,
} from "antd";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { UploadOutlined, StarOutlined } from "@ant-design/icons";
import config from "../../../config";
import { professionalAction } from "../../../_actions/professional.actions";
import Compressor from "compressorjs";
import { authHeader } from "../../../_helpers";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalService } from "../../../_services";
import { KalamAndKayadTable } from "../FormsTable/KalamAndKayadTable";
import { NCRServiceAction } from "../../../_actions/ncr.service";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const NCRForm = forwardRef((props, ref) => {
  console.log("ncr form props", props);
  const baseUrl = config.apiGateway.baseUrl;
  const [form] = Form.useForm();
  const [progress, setProgress] = useState(0);
  // Image and PDF file lists are managed separately
  const [imageFileList, setImageFileList] = useState([]);
  const [pdfFileList, setPdfFileList] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectDistricts, setSelectDistricts] = useState();
  const [isKKButton, SetIsKKButton] = useState(false);
  const [kalams, setkalam] = useState([]);
  const [kayda, setkayda] = useState([]);
  const [kalamkayda, setKalamKyadaArr] = useState([]);
  const [head, setHead] = useState([]);
  const [headId, setHeadId] = useState();
  const [subHead, setSubHead] = useState([]);
  const [subHeadId, setSubHeadId] = useState();
  const [selectDistrictId, setSelectDistrictId] = useState();
  const { t } = useContext(LanguageContext);
  const [disableBeforeDate, setDisableBeforeDate] = useState(null);

  const headsList = () => {
    NCRServiceAction.headsList().then((res) => {
      res &&
        res.text().then((list) => {
          let data = JSON.parse(list);
          console.log("data", data);
          setHead(data);
        });
    });
  };

  const handleChange = (id) => {
    setHeadId(id);
    subHeadsList(id);
  };
  const handleSubHeadChange = (id) => {
    setSubHeadId(id);
  };
  const subHeadsList = (id) => {
    let obj = {
      id: id,
    };
    NCRServiceAction.subHeadList(obj).then((res) => {
      res &&
        res.text().then((list) => {
          let data = JSON.parse(list);
          console.log("data", data);
          setSubHead(data);
        });
    });
  };
  const deletekalamKayda = (values) => {
    if (values) {
      let tempkalamKayda = kalamkayda;
      let getIndex = _.findIndex(kalamkayda, values);
      let temp = tempkalamKayda.splice(getIndex, 1);
      if (temp && temp.length) {
        form.resetFields(["kalam"]);
        form.resetFields(["rules"]);
      }
      setTimeout(() => {
        setKalamKyadaArr([]);
        setKalamKyadaArr(tempkalamKayda);
      }, 100);
    }
  };

  const clearKalamSelected = () => {
    SetIsKKButton(false);
    form.resetFields(["kalam"]);
  };

  const onkaydaChange = (value) => {
    clearKalamSelected();
    props.onKaydaChange(value);
  };

  useEffect(() => {
    headsList();
  }, []);

  useEffect(
    (res) => {
      if (
        props.dataStates &&
        props.dataStates.pc_acts &&
        props.dataStates.pc_acts
      ) {
        setkayda([...props.dataStates.pc_acts]);
      }
    },
    [props.dataStates]
  );

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    professionalService.getDistrict(user.cityId).then((res) => {
      setDistricts(res.pc_districts);
    });
  }, [form]);

  const getDistrictName = () => {
    if (districts && districts.length) {
      const found = districts.find(
        (o) => String(o.id) === String(props.district)
      );
      if (found) {
        form.setFieldsValue({
          action_taken_police_station: found.DistrictName,
        });
        form.setFieldsValue({
          districtId: found.id,
        });
      }
    }
  };
  useEffect(() => {
    if (props.role === "2" && districts && districts.length && props.district) {
      getDistrictName();
    }
  }, [props.role, districts, props.district]);

  const handelSelectDistricts = (e) => {
    setSelectDistricts(e);
    getDistrictId(e);
  };
  const getDistrictId = (e) => {
    if (districts && districts.length) {
      const found = districts.find((o) => String(o.DistrictName) === String(e));
      console.log("found", found);
      if (found) {
        form.setFieldsValue({
          districtId: found.id,
        });
      }
    }
  };

  const disableFutureDates = (current) => {
    return current && current > moment().endOf("day");
  };

  const onFinish = (values) => {
    // Attach kalam & kayda array
    const kalamAndKayda = [...kalamkayda];

    // Final form object
    const finalObj = {
      ...values,
      kalamAndKayda, // FIX: Correct key name
      heading: headId,
      // sub_heading: subHeadId,
    };

    console.log("finalObj", finalObj);

    props.ncrInformationFinish(finalObj);
  };

  const getActsNames = (id) => {
    const { pc_acts } = props.dataStates;
    if (pc_acts && pc_acts.length) {
      return (
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0] &&
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0].kayda
      );
    }
  };
  useImperativeHandle(ref, () => ({
    async submitForm() {
      try {
        const values = await form.validateFields(); // runs validation and returns values

        // Manually trigger onFinish with values
        props.ncrInformationFinish({
          ...values,
          kalamAndKayda: [...kalamkayda],
          heading: headId,
          // sub_heading: subHeadId,
        });

        return true;
      } catch (err) {
        console.log("Validation failed:", err);
        return false;
      }
    },
    resetForm() {
      form.resetFields();
    },
  }));

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.pc_kalams) {
        setkalam([...props.dataStates.pc_kalams]);
      }
    },
    [props.dataStates && props.dataStates.pc_kalams]
  );
  const addNewKalamKayda = () => {
    let ob = {
      rules: form.getFieldsValue().rules,
      kalam: form.getFieldsValue().kalam,
      rulesName: getActsNames(form.getFieldsValue().rules),
    };
    setKalamKyadaArr([
      ...kalamkayda,
      {
        ...ob,
      },
    ]);
  };

  return (
    <div>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item
              name="ncr_registernumber"
              label="NCR number"
              rules={[{ required: true, message: "Please " }]}
            >
              <InputNumber
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                min={0}
                max={5000}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                style={{ width: "100%" }}
                placeholder="Please enter user NCr. Number only"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {props.role == "4" && (
              <Form.Item
                name="action_taken_police_station"
                label={t("action_taken_police_station")}
                rules={[{ required: true, message: "Please choose " }]}
              >
                <Select
                  optionFilterProp="children"
                  placeholder="NCR दाखल पो.स्टे"
                  onChange={(e) => handelSelectDistricts(e)}
                  value={selectDistricts}
                >
                  {districts &&
                    districts.length > 0 &&
                    districts.map((res) => (
                      <Option key={res.id} value={res.DistrictName}>
                        {res.DistrictName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            {props.role == "2" && (
              <Form.Item
                name="action_taken_police_station"
                label="NCR दाखल पो.स्टे"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder={t("action_taken_police_station")}
                  disabled
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              label="घटना घडल्याची तारीख व वेळ"
              name="occurrence_datetime"
              rules={[{ required: true, message: "Please " }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                format="YYYY-MM-DD HH:mm"
                inputReadOnly
                onChange={(val) => {
                  if (val) {
                    setDisableBeforeDate(val);
                    form.setFieldsValue({
                      recorded_datetime: null,
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="recorded_datetime"
              label="माहिती नोंदवल्याची तारीख व वेळ"
              rules={[{ required: true, message: "Please " }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                format="YYYY-MM-DD HH:mm"
                inputReadOnly
                disabledDate={(current) => {
                  if (!disableBeforeDate) return false;

                  // disable all dates BEFORE the selected date
                  return current && current < disableBeforeDate.startOf("day");
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <p className="section-title">घटना प्रकार (NC)</p>
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item
              name="heading"
              label="शीर्षक"
              rules={[{ required: true, message: "Please " }]}
            >
              <Select
                name="headId"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={headId}
              >
                {head &&
                  head.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {subHead.length > 0 && (
            <Col span={12}>
              <Form.Item
                name="sub_heading_name"
                label="घटनेचा प्रकार"
                rules={[{ required: true, message: "Please " }]}
              >
                <Select
                  name="sub_heading_name"
                  value={subHeadId}
                  onChange={(e) => {
                    handleSubHeadChange(e);
                  }}
                  mode="multiple"
                >
                  {subHead.map((res, index) => (
                    <Option key={index} value={res.name}>
                      {res.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={24}>
          <Col span={15}>
            <Form.Item
              name="rules"
              label={t("law")}
              rules={[{ required: true, message: "Please select a rule" }]}
            >
              <Select
                placeholder="Please select a rule"
                showSearch
                onChange={onkaydaChange}
                filterOption={(input, option) =>
                  option?.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {kayda &&
                  kayda.map((res, index) => (
                    <Option key={index} value={res.act_cd}>
                      {res.kayda}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              name="kalam"
              label={t("section")}
              rules={[{ required: true, message: "Please select a kalam" }]}
            >
              <Select
                placeholder="Please select a kalam"
                showSearch
                onChange={() => {
                  SetIsKKButton(true);
                }}
                filterOption={(input, option) =>
                  option?.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {kalams &&
                  kalams.map((res, index) => (
                    <Option key={index} value={res.section}>
                      {res.section}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item>
              <Button
                style={{ marginTop: "30px" }}
                type="button"
                disabled={!isKKButton}
                onClick={addNewKalamKayda}
              >
                {t("add")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            {kalamkayda && kalamkayda.length ? (
              <KalamAndKayadTable
                data={kalamkayda}
                deletekalamKayda={deletekalamKayda}
                professionals={props.dataStates}
              ></KalamAndKayadTable>
            ) : null}
          </Col>
        </Row>
        <p className="section-title">अधिकारी माहिती</p>
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item
              label="अधिकारी / कर्मचारी चे नाव"
              name="officer_name"
              rules={[{ required: true, message: "Please " }]}
            >
              <Input placeholder="Please enter user name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="फोन नंबर"
              name="officer_mobile_no"
              rules={[
                {
                  required: true,
                  message: "Please enter a valid 10-digit mobile number",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit mobile number",
                },
              ]}
            >
              <Input
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={18}>
          <Col span={12}>
            <Form.Item
              label="केलेली कारवाई"
              rules={[{ required: true, message: "Please choose " }]}
              name="actions_taken"
            >
              <Select>
                <Option value="कारवाई नाही">कारवाई नाही</Option>
                <Option value="तक्रारदारास न्यायालयात जाण्याचा सल्ला दिला">
                  तक्रारदारास न्यायालयात जाण्याचा सल्ला दिला
                </Option>
                <Option value="पोलिस अधिकाऱ्याने न्यायालयात गेले पाहिजे">
                  पोलिस अधिकाऱ्याने न्यायालयात गेले पाहिजे
                </Option>
                <Option value="प्रतिबंधात्मक कारवाई">
                  प्रतिबंधात्मक कारवाई
                </Option>
                <Option value="प्रथम खबर नोंद करणे">प्रथम खबर नोंद करणे</Option>
              </Select>
            </Form.Item>
          </Col>

          <Form.Item name="districtId">
            <Input type="hidden" />
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
});
